export const menus = [
    {
        title: 'Insights',
        iconClass: 'fa fa-lightbulb',
        route: '/insights',
        allowed: ['managers', 'management', 'admin'],
    },
    {
        title: 'Dashboards',
        iconClass: 'fa fa-dashboard',
        children: [
            { title: 'LearnTracker', route: '/learn-tracker', allowed: ['managers', 'admin'], lms: 'accelerate' },
            { title: 'ObjectiveTracker', route: '/objective-tracker', module: 'objectives' },
            { title: 'PathwayTracker', route: '/pathway-tracker', allowed: ['managers', 'admin'], module: 'pathways' },
            { title: 'ReviewTracker', route: '/review-tracker', allowed: ['managers', 'admin'] },
        ],
        allowed: ['managers', 'management', 'admin'],
    },
    {
        title: 'Coaching',
        iconClass: 'fa fa-chart-user',
        route: '/develop/performance-dashboard',
    },
    {
        title: 'MyDevelopment',
        iconClass: 'fa fa-line-chart',
        children: [
            { title: 'Objectives', route: '/objectives', module: 'objectives' },
            { title: 'Learning', route: '/develop/learning', lms: 'accelerate' },
            { title: 'Reviews', route: '/develop/reviews' },
            { title: 'Pathways', route: '/develop/pathways', module: 'pathways' },
        ],
    },
    {
        title: 'Blogs',
        iconClass: 'fa fa-comments',
        route: '/blog',
        module: 'blogs',
    },
    {
        title: 'KnowledgeBank',
        iconClass: 'fa fa-bank',
        route: '/knowledge-bank',
        module: 'knowledge',
    },
    {
        title: 'Pitchbacks',
        iconClass: 'fa fa-video-camera',
        route: '/pitchback',
        module: 'objectives',
    },
];
